// extracted by mini-css-extract-plugin
export default {"container-wrapper":"Body_container-wrapper__O3LQl","container":"Body_container__eG32B","loading":"Body_loading__Za-5t","hide":"Body_hide__TlljD","hide-soft":"Body_hide-soft__Dumtt"};